// removed by extract-text-webpack-plugin
module.exports = {"emailForm":"EmailForm__emailForm__37-qi"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/EmailForm/EmailForm.css
// module id = 149
// module chunks = 0